import type {Raffle, RaffleApi, RafflesApiResponse} from "./raffles.types";

const toNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

export const adaptRaffle = (api: RaffleApi): Raffle => ({
  id: String(api.id ?? ""),
  title: api.title ?? api.name ?? "Sorteo",
  description: api.description ?? "",
  image: api.cover ?? api.image ?? null,
  status: api.status ?? "",
  prize: api.prize ?? "",
  drawDate: api.draw_date ?? api.drawDate ?? "",
  ticketPrice: toNumber(api.ticket_price ?? api.ticketPrice),
});

export const adaptRaffles = (response: RafflesApiResponse | RaffleApi[]): Raffle[] => {
  if (Array.isArray(response)) return response.map(adaptRaffle);
  const list =
    (Array.isArray(response?.data?.data) ? response.data?.data : null) ??
    (Array.isArray(response?.raffles) ? response.raffles : null);
  if (!list) return [];
  return list.map(adaptRaffle);
};
